module.exports = __webpack_public_path__ + "static/charlotte-cf19a8132faeb9f38f02cbeb16fff424.png";